export const REGISTRY_TEMPLATES = [
  {
    id: 1,
    name: "Solicitare certificat de atestare fiscala",
    department: "Taxe si impozite",
    type: "Intrare",
    numberOfDaysToRespond: 30,
    descriptionPrefix: "Solicitare certificat de atestare fiscala - ",
  },
  {
    id: 2,
    name: "Adeverinta domiciliu",
    department: "Agricol",
    type: "Intrare",
    numberOfDaysToRespond: 30,
    descriptionPrefix: "Adeverinta domiciliu - ",
  },
    {
    id: 3,
    name: "Adeverinta rol",
    department: "Agricol",
    type: "Intrare",
    numberOfDaysToRespond: 30,
    descriptionPrefix: "Adeverinta rol - ",
  },
    {
    id: 4,
    name: "Autorizatie de construire",
    department: "Urbanism",
    type: "Intrare",
    numberOfDaysToRespond: 30,
    descriptionPrefix: "Cerere autorizatie de construire - ",
  },
  {
    id: 5,
    name: "Adresa institutie",
    department: "",
    type: "Intrare",
    numberOfDaysToRespond: 15,
    descriptionPrefix: "Adresa institutie - ",
  },
  {
    id: 6,
    name: "Raspuns solicitare",
    department: "",
    type: "Iesire",
    numberOfDaysToRespond: 0,
    descriptionPrefix: "Raspuns la solicitarea nr. ",
  },
];
